(function () {
  'use strict';

  var STORAGE_KEY = 'almaMarbellaCartReservationExpiry';
  var DEFAULT_MINUTES = 10;
  var memoryExpiry = null;

  function pad(n) {
    n = Math.max(0, n);
    return n < 10 ? '0' + n : '' + n;
  }

  function readStoredExpiry() {
    try {
      var v = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      return isNaN(v) ? null : v;
    } catch (e) {
      return null;
    }
  }

  function writeStoredExpiry(value) {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (e) {}
  }

  function getExpiry(minutes) {
    var duration = minutes * 60 * 1000;
    var now = Date.now();

    if (memoryExpiry && memoryExpiry > now) {
      return memoryExpiry;
    }

    var stored = readStoredExpiry();

    if (stored && stored > now) {
      memoryExpiry = stored;
      return memoryExpiry;
    }

    memoryExpiry = now + duration;
    writeStoredExpiry(memoryExpiry);
    return memoryExpiry;
  }

  function tickAll() {
    var banners = document.querySelectorAll('[data-reservation-timer]');
    if (!banners.length) return;

    banners.forEach(function (el) {
      var minutes = parseFloat(el.getAttribute('data-reservation-minutes')) || DEFAULT_MINUTES;
      var timeEl = el.querySelector('[data-reservation-time]');
      if (!timeEl) return;

      var expiry = getExpiry(minutes);
      var remaining = expiry - Date.now();

      if (remaining <= 0) {
        memoryExpiry = Date.now() + minutes * 60 * 1000;
        writeStoredExpiry(memoryExpiry);
        remaining = minutes * 60 * 1000;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var m = Math.floor(totalSeconds / 60);
      var s = totalSeconds % 60;

      timeEl.textContent = pad(m) + ':' + pad(s);
    });
  }

  tickAll();
  setInterval(tickAll, 1000);
})();
